// extracted by mini-css-extract-plugin
export default {"container":"packageInfoItem-module__container__vwuTI","iconButton":"packageInfoItem-module__iconButton__B0n2U","content":"packageInfoItem-module__content__1SNDG"};